
<template>
  <v-form ref="form" lazy-validation>
    <v-select 
      :items="companies"
      :loading="loading"
      item-value="attributes.gateway_key"
      item-text="attributes.name"
      :readonly="read_only" 
      :rules="gatewayRules"
      label="Chave pix" 
      prepend-icon="mdi-key"
      v-model="selected_key"
      :clearable="false"
    >
      <template v-slot:item="{item}">
        {{item.attributes.name}} ({{item.attributes.gateway_key}})
      </template>
      <template v-slot:selection="{item}">
        {{item.attributes.name}} ({{item.attributes.gateway_key}})
      </template>
    </v-select>
  </v-form>
</template>

<script>
import Api from '@/api/index'
import validations from '@/mixins/validations.js'

export default {
  name: 'PixGatewayForm',
  mixins:[validations],
  data() {
    return {
      selected_key: "",
      companies: [],
      model_form: false,
      gatewayRules: [
        v => !!String(v || '').trim() || 'Gateway key é obrigatória',
      ],
      cnpj_rules: [
        v => !!v || 'Campo é obrigatório',
        v => v && v.length == 18 || 'CNPJ deve ser completo',
        v => v && this.validarCNPJ(v) || 'CNPJ inválido'
      ],
      loading: false,
    }
  },
  props:{
    read_only:{
      type: Boolean,
      default: false,
    },
    gateway_key:{
      type: String,
      default: () => '',
    },
  },
  methods:{
    getData(){
      this.getCompanies()
      this.setSelectedKey()
    },
    getSelectedKey(){
      return String(this.selected_key || '').trim()
    },
    setSelectedKey(){
      this.selected_key = this.gateway_key
    },
    cancelEdit(){
      this.setSelectedKey()
    },
    getCompanies(){
      this.loading = true
      let params = { only_with_credentials: true }
      Api.Company.index(params).then(r => r.data).then(res => {
        this.companies = [...res.data]
      }).finally(()=>{
        this.loading = false
      })
    },
    validate(){
      return this.$refs.form.validate() && !!this.getSelectedKey()
    },
  },
  mounted () {
    this.getData();
  },
  watch:{
    gateway_key(){
      this.setSelectedKey()
    }
  }
}
</script>
